import React, { useState, useContext, useEffect } from "react";
import MainLayout from "./MainLayout";
import DoneIcon from "@mui/icons-material/Done";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../index.css";
import { StoreContext } from "../../store";
import routeConstant from "../../../route/compoent/routeConstant";
import instance from "../api/interceptor";
import { path } from "../../constants/apiPath";
import axios from "axios";

function LayoutCreateOrder(props) {
  const location = useLocation();
  const navigation = useNavigate();
  const context = useContext(StoreContext);

  useEffect(() => {
    if (!context.defaultValue.serviceLevel.length) {
      const service = instance.get(path.SERVICE_LEVEL);
      const transport = instance.get(path.TRANSPORT_MODE);
      const container = instance.get(path.CONTAINER_MODE);
      const containerType = instance.get(path.GET_CONTAINER_TYPE);
      const originCountry = instance.get(path.GET_COUNTRY);
      const currency = instance.get(path.GET_CURRENCY);
      const incoTerm = instance.get(path.INCO_TERM);
      const orderStatus = instance.get(path.ORDER_STATUS);
      const packType = instance.get(path.PACK_TYPE);
      const weightType = instance.get(path.GET_WEIGHT);
      const dimenssions = instance.get(path.GET_DIMENSSIONS);
      const volume = instance.get(path.GET_VOLUME);
      axios
        .all([
          service,
          transport,
          container,
          originCountry,
          currency,
          incoTerm,
          orderStatus,
          packType,
          weightType,
          dimenssions,
          volume,
          containerType
        ])
        .then(
          axios.spread((...responses) => {
            console.log("response", responses);
            context.setDefaultValue({
              ...context.defaultValue,
              serviceLevel: responses[0].data ?? [],
              transportMode: responses[1].data ?? [],
              containerMode: responses[2].data ?? [],
              originCountry: responses[3].data ?? [],
              currency: responses[4].data ?? [],
              incoTerm: responses[5].data ?? [],
              orderStatus: responses[6].data ?? [],
              packType: responses[7].data ?? [],
              weightType: responses[8].data ?? [],
              dimenssionsUnit: responses[9].data ?? [],
              volumeUnit: responses[10].data ?? [],
              containerType: responses[11].data ?? []
            });
          })
        )
        .catch((errors) => {
          console.log("api failed in context", errors);
        });
    }
  }, []);

  const orderState = [
    routeConstant.CREATE_ORDER,
    routeConstant.LINE_DETAIL,
    routeConstant.ORDER_PLAN,
    routeConstant.DOC_UPLOAD,
    routeConstant.CONFIRMATION
  ];

  const editDashboarOrderState = [
    routeConstant.EDIT_CREATE_ORDER,
    routeConstant.EDIT_LINE_DETAIL,
    routeConstant.EDIT_ORDER_PLAN,
    routeConstant.EDIT_DOC_UPLOAD,
    routeConstant.EDIT_CONFIRMATION
  ];

  const editListOrderState = [
    routeConstant.LIST_EDIT_CREATE_ORDER,
    routeConstant.LIST_EDIT_LINE_DETAIL,
    routeConstant.LIST_EDIT_ORDER_PLAN,
    routeConstant.LIST_EDIT_DOC_UPLOAD,
    routeConstant.LIST_EDIT_CONFIRMATION
  ];
  const pathname = location.pathname.includes("dashboard/edit-order")
    ? editDashboarOrderState.at(
        editDashboarOrderState.indexOf(location.pathname) + 1
      )
    : location.pathname.includes("order-list/edit-order")
    ? editListOrderState.at(editListOrderState.indexOf(location.pathname) + 1)
    : orderState.at(orderState.indexOf(location.pathname) + 1);

  const index = location.pathname.includes("dashboard/edit-order")
    ? editDashboarOrderState.indexOf(location.pathname)
    : location.pathname.includes("order-list/edit-order")
    ? editListOrderState.indexOf(location.pathname)
    : orderState.indexOf(location.pathname);

  return (
    <>
      <div className="_orderCreation">
        <div className="_order-creation-timeline-Parent">
          <div className="_order-creation-timeline">
            <hr />
            <div className="_order-creation-timeline-div">
              <div
                className={`_order-creation-timeline-name first ${
                  index === 0 ? "active" : index > 0 ? "done" : ""
                }`}
              >
                <div className="_order-creation-timeline-dot ">
                  <div>{index > 0 ? <DoneIcon /> : null}</div>
                </div>
                <p>Order Specifics</p>
              </div>
              <div
                className={`_order-creation-timeline-name first ${
                  index === 1 ? "active" : index > 1 ? "done" : ""
                }`}
              >
                <div className="_order-creation-timeline-dot">
                  <div>
                    <div>{index > 1 ? <DoneIcon /> : null}</div>
                  </div>
                </div>
                <p>Line Details</p>
              </div>
              <div
                className={`_order-creation-timeline-name first ${
                  index === 2 ? "active" : index > 2 ? "done" : ""
                }`}
              >
                <div className="_order-creation-timeline-dot">
                  <div>{index > 2 ? <DoneIcon /> : null}</div>
                </div>
                <p>Order Plan</p>
              </div>
              <div
                className={`_order-creation-timeline-name first ${
                  index === 3 ? "active" : index > 3 ? "done" : ""
                }`}
              >
                <div className="_order-creation-timeline-dot">
                  <div>{index > 3 ? <DoneIcon /> : null}</div>
                </div>
                <p>E-Doc Upload</p>
              </div>
              <div
                className={`_order-creation-timeline-name last ${
                  index === 4 ? "active" : index > 4 ? "done" : ""
                }`}
              >
                <div className="_order-creation-timeline-dot">
                  <div>{index > 4 ? <DoneIcon /> : null}</div>
                </div>
                <p>Confirmation</p>
              </div>
            </div>
          </div>
        </div>
        {props.children}
      </div>
      <div className="_order-creation-footer">
        <div className="_order-creation-footer-left">
          <div className="_solidButton">
            <button
              onClick={() => {
                navigation(-1);
              }}
              disabled={index === 0 ? true : false}
            >
              PREVIOUS
            </button>
          </div>
          {/* {index === 4 ? null : (
            <div className="_outlineButton">
              <button
                onClick={() => {
                  if (index === 1) {
                    context.setModalOpen(true);
                  }
                }}
              >
                SAVE AND CONTINUE LATER
              </button>
            </div>
          )} */}
        </div>
        <div className="_order-creation-footer-right">
          <div className="_solidButton">
            <button
              // disabled={index === 4 ? true : false}
              onClick={() => {
                if (index === 4) {
                  props.onNextHandler("");
                } else {
                  props.onNextHandler(
                    pathname
                    // props.editComp
                    //   ? editDashboarOrderState[index + 1]
                    //   : orderState[index + 1]
                  );
                  // navigation();
                }
              }}
            >
              {location.pathname.includes("confirmation")
                ? props.editComp
                  ? "UPDATE ORDER"
                  : "CREATE ORDER"
                : "NEXT"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default LayoutCreateOrder;
